var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel_sale"},[_c('saleTableGiftCard'),_c('div',{staticClass:"settlementBox"},[_c('saleGiftCardSettlement')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }